import { render, staticRenderFns } from "./DonutChart88.vue?vue&type=template&id=48b5ea19&scoped=true"
import script from "./DonutChart88.vue?vue&type=script&lang=js"
export * from "./DonutChart88.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b5ea19",
  null
  
)

export default component.exports